module.exports = __webpack_public_path__ + "static/f2d1423759923a3190300d4b6b313b9415559bd4bf570d99effe8a9bceddba3c-6d227137b959d2169d1967dd16331143.png";